import {MatrixClient, MsgType, TimelineEvents} from 'matrix-js-sdk';
import {
  SjMatrixMessageType,
  SystemMessageAction,
  SystemMessageData,
  SystemMessageEventContent
} from '@/types/matrix';

export const sendSystemMessage = async (
  matrixClient: MatrixClient,
  currentMatrixRoomId: string,
  actionType: SystemMessageAction,
  data: SystemMessageData
): Promise<void> => {
  try {
    const content = {
      body: actionType,
      msgtype: MsgType.Text,
      data: data
    };
    await matrixClient.sendEvent(
      currentMatrixRoomId,
      SjMatrixMessageType.SystemMessage as unknown as keyof TimelineEvents,
      content as SystemMessageEventContent
    );
  } catch (error) {
    console.error('Failed to send the system message', error);
    throw error;
  }
};
